import { colors } from "src/theme/colors";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { SIDEBAR } from "src/components/FinaLayout/utils/sizes";
export const StyledItemLink = styled(Link)`
  border: none;
  background-color: ${({ isActive }) =>
    isActive ? colors.primary[15] : "white"};
  color: ${({ isActive }) => (isActive ? colors.primary[500] : "black")};;
  display: flex;
  align-items: center;
  font-weight: bold;
  /* Collapsed, the row is just the icon: centred in the rail, with the label
     out of the flow instead of overflowing it and being clipped. */
  justify-content: ${({ $collapse }) => ($collapse ? "center" : "flex-start")};
  width: ${({ $collapse }) => ($collapse ? "40px" : "175px")};
  border-radius: 5px;
  padding: ${({ $collapse }) => ($collapse ? "8px 0" : "8px 16px 8px 16px")};
  column-gap: 14px;

  span {
    display: ${({ $collapse }) => ($collapse ? "none" : "inline")};
  }
  
  & {
    svg {
      fill: ${({ isActive }) => (isActive ? colors.primary[500] : "black")};
      font-weight: bold;
    }
  }
  &:hover {
    background-color: ${colors.primary[15]};
    color: ${colors.primary[500]};
    cursor: pointer;
    svg {
      fill: ${colors.primary[500]};
      font-weight: bold;
    }
`;
export const StyledUsername = styled.div`
  display: flex;
  align-items: center;
  /* 2rem of padding does not fit in the collapsed rail, so the avatar was
     pushed straight out of it. Collapsed, it is centred with no padding. */
  justify-content: ${({ $collapse }) => ($collapse ? "center" : "flex-start")};
  gap: ${({ $collapse }) => ($collapse ? "0" : "5px")};
  border-top: 1px solid #e8f1ff;
  padding: ${({ $collapse }) => ($collapse ? "1.25rem 0" : "2rem")};
  /* While the rail animates open, the name is laid out before there is room
     for it. Clip it here and it slides into view instead of reflowing —
     and it never spills outside the rail on the way. */
  overflow: hidden;

  /* The avatar is a flex item, and antd gives it overflow: hidden, which makes
     its automatic minimum width 0. A long name competing for the row shrank it
     from a circle into an oval, so keep it at its own size and let the name
     wrap instead. */
  .ant-avatar {
    flex: none;
  }
`;
export const StyledUsernameText = styled.span`
  font-size: 14px;
  color: #000000;
  font-weight: 400;
  /* Pinned to the width it will have once the sidebar is open — the row's
     2rem of padding either side, the 32px avatar and the 5px gap — so the
     name wraps the same way at every point of the transition. Left to size
     itself, it was laid out against a rail still 64px wide and broke one
     word per line, then reflowed as the width grew. */
  flex: none;
  width: calc(${SIDEBAR} - 4rem - 37px);
`;
